export default function SectionLabel({ children, className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="w-6 h-px bg-clay inline-block flex-shrink-0" />
      <span className="text-eyebrow font-sans font-normal uppercase tracking-[0.18em] text-clay">
        {children}
      </span>
    </div>
  );
}
